import {mapGetters} from "vuex"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {getPaymentCheckoutLink, getPaymentPortalLink} from "@/components/pages/profile/subscription/graphql"
import {listPriceModels} from "@/components/pages/profile/graphql"
import BaseUrl from "@/mixins/BaseUrl"

export default {
  mixins: [BaseUrl],
  computed: {
    ...mapGetters('auth', ['groupPriceModel']),
  },
  methods: {
    /**
     * Navigate to stripe to change the abo
     * TODO
     * If priceId is set, priceId will be used to navigate to the produtct with priceId in stripe.
     * If priceId is not set, aboId AND duration have to be set to be able to determine the priceId to navigate to in stripe.
     *
     * This method is only to be called for logged-in users.
     *
     * @param priceId - the abo-id in stripe
     * @param aboId - the abo-id in finCraft (EXTENDED/ADVANCED)
     * @param duration - the abo duration (monthly = 1M / yearly = 1Y)
     */
    async navigateToStripeChangeAbo(priceId, aboId, duration) {
      if (!priceId && aboId && duration) {
        const result = await API.graphql({
          // listPriceModelsGuests is a minimum query to get the price models
          query: listPriceModels
        })

        console.log("listPriceModelsGuests result", result)
        if (result) {
          const priceModels = result.data.listPriceModels.items
          const priceModel = priceModels.find(i => i.id === aboId)
          priceId = duration === '1M' ? priceModel.priceId : duration === '1Y' ? priceModel.price1YId : undefined
        }
      }
      console.log("priceId, aboId, duration", priceId, aboId, duration)

      if (priceId) {
        const baseUrl = this.getBaseURL()
        const {data} = await API.graphql(graphqlOperation(getPaymentCheckoutLink, {
          priceId: priceId,
          cancelUrl: baseUrl + '/protected/myProfile/subscription' + '?success=false',
          successUrl: baseUrl + '/protected/myProfile/subscription' + '?success=true'
        }))
        const url = data.getPaymentCheckoutLink
        console.log("opening getPaymentCheckoutLink: " + url)
        window.open(url, '_self')
      } else {
        await this.navigateToStripePaymentPortalLink()
      }
    },
    /**
     * TODO
     */
    async navigateToStripePaymentPortalLink() {
      const baseUrl = this.getBaseURL()
      const {data} = await API.graphql(graphqlOperation(getPaymentPortalLink, {
        returnUrl: baseUrl + '/protected/myProfile/subscription'
      }))
      const url = data.getPaymentPortalLink
      console.log("opening getPaymentPortalLink: " + url)
      window.open(url, '_self')
    },
  }
}
